import styled from "styled-components";
import Image from "../Image/Image";

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 48%;
  flex: 1;
`;

export const LeftContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 223.68px;
  gap: 12px;

  @media (max-width: 768px) {
    min-width: unset;
  }
`;

export const ArrowContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  transform: translate(-50%, 30%);
  filter: drop-shadow(0px 0px 2.5px rgba(0, 0, 0, 0.5));

  @media (max-width: 768px) {
    transform: translate(-50%, -50%);
  }
  @media (max-width: 450px) {
    svg {
      width: 40px;
    }
  }

  @media (max-width: 350px) {
    svg {
      width: 30px;
    }
  }
`;

export const UploadImageContainer = styled.div`
  height: 310px;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 12px;
  /* border: 1px dashed #345884; */
  border: none;
  background: #0e1c31;

  @media (max-width: 768px) {
    height: 250px;
  }
`;

export const UploadActions = styled.div`
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  z-index: 2;
`;

const uploadActionStyles = `
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.37);
  backdrop-filter: blur(6.849999904632568px);
  border: 0.5px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  outline: none;
  cursor: pointer;
`;

export const GalleryTriggerButton = styled.button`
  ${uploadActionStyles}
  width: 33px;
  min-width: 33px;
  height: 33px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    color: #fff;
  }

  @media (max-width: 375px) {
    width: 28px;
    min-width: 28px;
    height: 28px;
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

export const UploadImageButton = styled.button`
  ${uploadActionStyles}
  border-radius: 100px;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.07px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  height: 33px;
  padding: 0 12px;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 0 10px;
    width: auto;
  }

  @media (max-width: 375px) {
    height: 28px;
    font-size: 13px;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  position: absolute;
  top: 5px;
  left: ${(props) => (props.$shift ? `calc(5px + ${props.$shift}px)` : "5px")};
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;
  width: 36px;
  height: 36px;
  padding-bottom: 2px;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const CropButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  top: 5px;
  padding: 6px;
  outline: none;
  border: none;
  right: ${(props) => (props.$shift ? `calc(5px + ${props.$shift}px)` : "5px")};
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;

  svg {
    path {
      stroke: white;
    }
  }
`;

export const CheckboxText = styled.div`
  position: relative;
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const CheckboxContainerColumn = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;

  @media (max-width: 768px) {
    /* display: none; */
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  padding: 6px 8px;
  background: #0e1c31;
  border-radius: 12px;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  align-self: stretch;
  flex-direction: row;
  height: 33px;

  border-radius: 1000px;
  border: 0.5px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.37);

  @media (max-width: 768px) {
    /* display: none; */
  }
`;

export const StyledImage = styled(Image)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${(props) =>
    props.$hideImageContainer ? "transparent" : "#fff2"};
  max-width: 100%;

  img {
    border-radius: 12px;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const Badge = styled.div`
  transform: rotate(14.909deg);

  position: absolute;
  right: -24px;
  top: -8px;
`;
